<script>
  /* Executable code section of the program */
  //Tools importation
  import { breakInfo } from "../../apis/storage";

  //Auxiliary variables
  export let programmedBreak;
  export let networking;

  //Function to change the form
  const inviteAttendees = (breakData, data) => {
    //Designation of networking info
    $breakInfo = breakData;
    $breakInfo.breakDate = data;
    
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<div
  class="breaksCards"
  class:selectedBreak={$breakInfo.id === programmedBreak.id}
  on:click={() => inviteAttendees(programmedBreak, networking.eventDay)}
  on:keypress={() => inviteAttendees(programmedBreak, networking.eventDay)}
>
  <h3>{programmedBreak.breakTittle}</h3>
  <p class="subtext">
    Date: {networking.eventDay} <br />
    Time: {programmedBreak.startTime} - {programmedBreak.endTime}
    <br />
  </p>
</div>

<!-- End of the section -->
<style>
  /* Section to place the code styles */

  .breaksCards {
    width: 30%;
    height: auto;
    background-color: white;
    margin: 10px;
    padding: 20px;
  }
  .breaksCards:hover {
    cursor: pointer;
  }

  .selectedBreak {
    width: 30%;
    height: auto;
    border: 1px solid red;
    margin: 10px;
    padding: 20px;
    color: red;
  }

  .subtext {
    font-size: 15px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .breaksCards {
      width: 45%;
      height: auto;
      margin: 10px;
      padding: 20px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .breaksCards {
      width: 80%;
    }
  }
  /* End of the section */
</style>
